import { Directive, EventEmitter, HostListener, Output } from "@angular/core";

/**
 * Directive to handle clicks on media object anchor tags in AI answer text.
 * 
 * The text comes as raw text from the service, html formatted etc from the LLM
 * with citations decorated by the server as simple anchor tags. All of our pages
 * change the base via a <base> tag in the head. So we can't rely on the standard
 * functionality of html and anchor tags because the base redirects the hash ref
 * to the root of the site. To hack around this, this directive listens for clicks
 * on these anchor tags and emits an event while preventing the default behavior that
 * is broken because of our use of the base tag.
 */
@Directive({
    selector: "[gpt-content]",
    standalone: false
})
export class AiAnswerTextDirective {
    @Output() objectClicked: EventEmitter<string> = new EventEmitter<string>();

    @HostListener("click", ["$event"])
    handle(event: MouseEvent) {
        const target = event.target as HTMLElement;
        const href = target?.getAttribute("href");
        if (target?.nodeName === "A" && href?.startsWith("#REF")) {
            event.preventDefault();
            event.stopPropagation();

          this.objectClicked.emit(href.replace("#REF", ""));
        }
    }
}
